import request from "axios"
import { API } from "@/constants/config"

/**
 *  根据农行token换取用户信息及jtoken
 * @param token
 * @returns
 */
export async function getUserInfo(token: string) {
  try {
    // return {
    //   oauth_uname: "18817513536",
    //   customer_id: "256",
    //   expires_in: "172800",
    //   ktoken:
    //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJHZHFReVdMR2g0aXU4dzdBelpGeTZwUlV1MTczcmtYZCIsInR5cCI6IkpXVCIsImV4cCI6MTY0ODAyMDI2NSwiYWxnIjoiSFMyNTYifQ.r3bAYOkL2bjxHZt4fMlV3mh4g0JVNsgLK7TnbIlr9_k",
    //   login_ip: "114.67.82.246",
    //   login_time: "2022-03-21 05:51:05",
    //   potoken:
    //     "71nhxKkxSKp7nrwi87MIqYGz9hbLNXSPtIjMVm3akz1j1pCgMmJcl9PiaNsFDDovoKLA4dWDdFdcqkw8KI4-wgQf-RzyOBZkp8e9NkDEEcOms7t9zvW5afiYTcQx6VhtySqM62L16I-XQeP1S4jtLnDLdQ5D7A4QPqta_g91LtX3DNvXZVeOF80epAX_XEBRkvcH5nzks9q3_apzgXUETzQuUW3E8moA-zJxihm2qyueae9fOZoKomtned1k4EfyZJIyOPaChm-mY7x8VZwvyg",
    //   jtoken:
    //     "71nhxKkxSKp7nrwi87MIqYGz9hbLNXSPtIjMVm3akz1j1pCgMmJcl9PiaNsFDDovoKLA4dWDdFdcqkw8KI4-wgQf-RzyOBZkp8e9NkDEEcOms7t9zvW5afiYTcQx6VhtySqM62L16I-XQeP1S4jtLnDLdQ5D7A4QPqta_g91LtX3DNvXZVeOF80epAX_XEBRkvcH5nzks9q3_apzgXUETzQuUW3E8moA-zJxihm2qyueae9fOZoKomtned1k4EfyZJIyOPaChm-mY7x8VZwvyg",
    //   user_name: "18817513536",
    //   user_type: "1",
    // }

    const result = await request.get(`${API}/v1/tokenAuth`, {
      params: { token },
    })

    return result.data
  } catch (error) {
    // 获取用户信息失败后, 重新登录
    window.location.href = `${window.location.origin}/#/passport/logout`
  }
}
